import {RecommendationsSlider} from 'components/RecommendationsSlider';
import React, {FC} from 'react';
import {IProductShortResponse} from 'modules/products/models';
import {ProductSnippetAnalyticsProvider} from 'modules/analytics/providers/ProductSnippetAnalyticsProvider';

interface IEventXTastingProductsSliderProps {
    tastingProductsData?: IProductShortResponse;
}

export const EventXTastingProductsSlider: FC<IEventXTastingProductsSliderProps> = ({tastingProductsData}) => {
    const {items} = tastingProductsData || {};

    if (!items?.length) {
        return null;
    }

    return (
        <ProductSnippetAnalyticsProvider>
            <RecommendationsSlider list={items} withArrows={true} />
        </ProductSnippetAnalyticsProvider>
    );
};
